/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Beides10Inputs */

const en__field_enum_tuda_beides10 = /** @type {(inputs: _Field_Enum_Tuda_Beides10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`both`)
};

const de__field_enum_tuda_beides10 = /** @type {(inputs: _Field_Enum_Tuda_Beides10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beides`)
};

/**
* | output |
* | --- |
* | "both" |
*
* @param {_Field_Enum_Tuda_Beides10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_beides10 = /** @type {((inputs?: _Field_Enum_Tuda_Beides10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Beides10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_beides10(inputs)
	return de__field_enum_tuda_beides10(inputs)
});
export { _field_enum_tuda_beides10 as "_field_enum_TUDA_BEIDES" }